import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { PosCaptchaModule } from 'src/app/shared/pos-captcha/pos-captcha.module';
import { ChangeForgetPasswordComponent } from './change-forget-password.component';



@NgModule({
  declarations: [ChangeForgetPasswordComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PosCaptchaModule
  ],
  providers: [ToastrModule],
  exports: [ChangeForgetPasswordComponent]
})
export class ChangeForgetPasswordModule { }
